<div class="mt-3">
    <span class="font-medium">Status</span>
    &nbsp;
    <p-dropdown appendTo="body" [options]="Status" [(ngModel)]="selectedStatus" (onChange)="onStatusChange()" optionLabel="name" styleClass="w-3">
    </p-dropdown>
    &nbsp;
</div>

<p-table #dt1 [value]="list" responsiveLayout="scroll" class="w-full m-5"
styleClass="p-datatable-sm" [rowHover]="true" paginatorDropdownAppendTo="body" [paginator]="true" [rows]="10"
[rowsPerPageOptions]="[5, 10, 20]" [paginator]="true" (onPage)="loadPaymentCollection($event)">
<ng-template pTemplate="header">
    <tr>
        <th>Invoice No</th>
        <th>Invoice Date</th>
        <th>Due Date </th>
        <th>Invoice Amount </th>
        <th>Paid Amount</th>
        <th>Discount</th>
        <th>Amount Due </th>
        <th>Status </th>

    </tr>
</ng-template>
<ng-template pTemplate="body" let-data>
    <tr>
        <td>{{ data.salesOrderNumber }}</td>
        <td>{{ data.invoiceDate | date: 'dd/MM/yy' }}</td>
        <td>{{ data.dueDate | date: 'dd/MM/yy' }}</td>
        <td>{{ data.invoiceAmount.toLocaleString('en-IN',{ minimumFractionDigits: 2, maximumFractionDigits: 2 }) }}</td>
        <td>{{ data.totalPaid.toLocaleString('en-IN',{ minimumFractionDigits: 2, maximumFractionDigits: 2 }) }}</td>
        <td>{{ data.discountTaken }}</td>
        <td>{{ data.amountDue.toLocaleString('en-IN',{ minimumFractionDigits: 2, maximumFractionDigits: 2 }) }}</td>
        <td>{{ data.arStatus }}</td>
    </tr>
</ng-template>
</p-table>